import { Message } from 'element-ui'
import { ElMessageOptions } from 'element-ui/types/message'

export function showInsertError(message: string): void {
  showTrackMessage(message, { type: 'error' })
}

export function showInsertSuccess(message: string): void {
  showTrackMessage(message, { type: 'success' })
}

export function showTrackMessage(
  message: string,
  option?: Partial<ElMessageOptions>,
): ReturnType<typeof Message> {
  const panel = document.getElementById('timeline-panel')
  const rect = panel?.getBoundingClientRect()
  const windowHeight = window.innerHeight
  return Message({
    message: message,
    customClass: 'track-message',
    duration: 1200,
    showClose: false,
    offset: windowHeight - (rect?.height ?? 0) + 8,
    ...option,
  })
}
